import { render } from "./TaskCategorizationChart.vue?vue&type=template&id=0ceca3c8&scoped=true"
import script from "./TaskCategorizationChart.vue?vue&type=script&lang=js"
export * from "./TaskCategorizationChart.vue?vue&type=script&lang=js"

import "./TaskCategorizationChart.vue?vue&type=style&index=0&id=0ceca3c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ceca3c8"]])

export default __exports__